export const DevURL = process.env.REACT_APP_BACKEND_BASE_URL;

// ? Authentication URL
export const GET_SESSION_ID = "/GetSessionID/01";
export const GET_HOME_CATEGORY = "/GetPosFullItemList/01";
export const GET_STORE_STOCK_LIST = "/GetPosStroreStockList/01";

export const URL = DevURL;
